import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { I18nPipe } from '../../pipes/i18n.pipe';
import { ExternalChannelAccessResponse, FixaResource } from '../../../core/models/login.model';
import { formatFixaContractDisplayFromList } from '../../../core/utils/fixa-contract-display.util';
import { unformatCnpj } from '../../../core/utils/cnpj.util';

@Component({
  selector: 'umkt-combo-selector',
  standalone: true,
  imports: [CommonModule, CnpjPipe, I18nPipe],
  templateUrl: './combo-selector.component.html',
  styleUrls: ['./combo-selector.component.scss'],
})
export class ComboSelectorComponent {
  @Input() externalAccess: ExternalChannelAccessResponse | null = null;
  @Input() selectedMobileDocument: string = '';
  @Input() selectedContractId: string = '';
  @Input() selectedSegment: 'mobile' | 'contract' = 'mobile';
  @Input() isLoading = false;

  @Output() mobileChange = new EventEmitter<string>();
  @Output() contractChange = new EventEmitter<FixaResource>();
  @Output() showAllProducts = new EventEmitter<void>();

  isDropdownOpen = false;

  get mobileDocument(): string {
    return (
      this.selectedMobileDocument ||
      this.externalAccess?.userRequest?.document ||
      ''
    );
  }

  get companyName(): string {
    return this.externalAccess?.userRequest?.business || '';
  }

  get contracts(): FixaResource[] {
    return Array.isArray(this.externalAccess?.contracts) ? this.externalAccess!.contracts : [];
  }

  get hasMultipleOptions(): boolean {
    return (this.mobileDocument ? 1 : 0) + this.contracts.length > 1;
  }

  get showContractLabel(): boolean {
    return this.selectedSegment === 'contract' && !!this.selectedContractId;
  }

  toggleDropdown(): void {
    if (this.isLoading) {
      return;
    }
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  onSelectMobile(): void {
    if (this.isLoading) {
      return;
    }

    const clean = unformatCnpj(this.mobileDocument || '');
    if (clean) {
      this.mobileChange.emit(clean);
    }
    this.isDropdownOpen = false;
  }

  onSelectContract(contract: FixaResource): void {
    if (this.isLoading) {
      return;
    }

    this.contractChange.emit(contract);
    this.isDropdownOpen = false;
  }

  onShowAllProducts(): void {
    if (this.isLoading) {
      return;
    }

    this.showAllProducts.emit();
    this.isDropdownOpen = false;
  }

  fixaContractLabel(customerAccountId: string): string {
    return formatFixaContractDisplayFromList(this.contracts, customerAccountId);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.combo-selector-dropdown')) {
      this.isDropdownOpen = false;
    }
  }
}

